import React from 'react'

interface TextProps {
  bold?: boolean
  className?: string
  id?: string
  shadow?: boolean
  size?: 'XS' | 'SM' | 'BASE' | 'LG' | 'XL' | '2XL'
  tabIndex?: number
  text: string
  type?: 'paragraph' | 'span'
}

const Text: React.FC<TextProps> = ({ bold, className, id, shadow, size, tabIndex, text, type }: TextProps) => {
  let twClassName: string
  switch (size) {
    case 'XS':
      twClassName = 'text-xs sm:text-xs md:text-xs lg:text-xs xl:text-sm '
      break
    case 'SM':
      twClassName = 'text-sm sm:text-sm md:text-base lg:text-lg xl:text-xl '
      break
    case 'LG':
      twClassName = 'text-base sm:text-md md:text-lg lg:text-xl2 xl:text-3xl '
      break
    case 'XL':
      twClassName = 'text-base sm:text-lg md:text-xl lg:text-4xl xl:text-6xl '
      break
    case '2XL':
      twClassName = 'text-base text-3xl sm:text-6xl md:text-6xl lg:text-6xl xl:text-6xl '
      break
    default:
      twClassName = 'text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl '
      break
  }

  twClassName += className ?? ''
  twClassName += bold !== undefined && bold ? ' font-bold' : ''
  twClassName += shadow !== undefined && shadow ? ' text-shadow' : ''

  if (type === 'paragraph') {
    return <p className={twClassName} id={id} tabIndex={tabIndex}>{text}</p>
  } else return <span className={twClassName} id={id} tabIndex={tabIndex}>{text}</span>
}

export default Text
